import { useEffect } from 'react';

/**
 * GTM 클릭 태그는 data-gtm-id 클릭마다 dataLayer 의 channel 값을 GA4 `funnel` 파라미터로 보낸다(비어 있으면 direct).
 * 화면에 있는 동안 channel 을 지정하고, 벗어나면 지워서 다른 화면의 클릭에 섞이지 않게 한다
 */
export const useGtmChannel = (channel: string | null | undefined) => {
  useEffect(() => {
    if (!channel) return;

    const dataLayer = ((window as any).dataLayer = (window as any).dataLayer || []);
    dataLayer.push({ channel });
    return () => {
      dataLayer.push({ channel: undefined });
    };
  }, [channel]);
};
